<template>
  <Btn :class="classNames" variant="bare" v-on="$listeners">
    <Media size="small" align="middle">
      <MediaLeft>
        <Icon id="filters" />
      </MediaLeft>
      <MediaBody class="text-truncate">
        <div class="text-negative">
          {{ $t('filters.label') }}
        </div>
        {{ activeFilters }}
      </MediaBody>
    </Media>
  </Btn>
</template>

<script>
export default {
  computed: {
    activeFilters() {
      return this.$store.state.live.mapFilters
        .map(filter => filter.label)
        .join(', ');
    },

    classNames() {
      return [
        'filters-button',
        { 'is-active': this.$store.state.live.mapFilters.length },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.filters-button {
  max-width: 260px;
  min-height: 37px;

  color: white;
  font-size: $font-size-small;
  font-weight: bold;
  text-align: left;
  text-transform: uppercase;

  &.is-active {
    color: $brand-400;
  }

  &:hover,
  &:focus,
  &.is-open {
    color: darken($brand-400, 8%);
  }
}
</style>
